module.exports = __webpack_public_path__ + "static/media/cat3.25d33f16.png";